import React from 'react'
import "./nf.css"
import { Link } from 'react-router-dom'
import linkArrow from '../../asset/arrowRight.svg'
import { useEffect } from 'react'


export const NotFound = () => {


  useEffect(() => {
    window.scrollTo(0, 0)

  }, [])
  return (
    <div className='errorSection'>
        <div className="center">
            <h1>ERROR 404</h1>
            <p>The page doesn't exist!</p>
            <p className='errorDes'>
                If you let us design your website, it will be gone for good. We are export in successfull user experience. We make sure that all your website path reach their destination. No more dead ends - only live begains.
            </p>
        </div>
        <div className="errorLinks">
            <Link to='/' className='detailLinks' >TAKE ME<br />BACK<img src={linkArrow} alt="" /></Link>
            <Link to='contact' className='detailLinks' >CONTACT<br />US<img src={linkArrow} alt="" /></Link>
        </div>
    </div>
  )
}
